import axiosInstanceWithoutInterceptor from "../axiosWithoutInterceptor";
import getConfig from "../config";
import { deduplicateRequest } from "./services/apiDeduplicationService";

// Config is retrieved lazily inside functions to support runtime configuration
const getLazyConfig = () => {
    const config = getConfig();
    return {
        appEnv: config.appEnv,
        dataService: config.hostnames.dataService,
    };
};

let featureFlagsPromise = null;

export async function getFeatureFlags(spec, { avataxAccountId, subjectId } = {}) {
    featureFlagsPromise = deduplicateRequest(featureFlagsPromise, async () => {
        const { appEnv, dataService } = getLazyConfig();
        const FEATURE_FLAG_API = `${dataService}/api/v1/features`;
        const specEnv = appEnv === "local" ? "dev" : appEnv;
        const configName = `${spec}.${specEnv}`;

        const requestData = { config: { names: [configName] } };
        if (avataxAccountId || subjectId) {
            requestData.data = {
                ...(subjectId && { subjectId }),
                ...(avataxAccountId && { avataxAccountId }),
            };
        }

        try {
            const { data } = await axiosInstanceWithoutInterceptor({
                method: "post",
                url: FEATURE_FLAG_API,
                baseURL: null,
                data: requestData,
                timeout: 5000, // Kill request after 5 seconds
            });

            if (Object.keys(data?.data || {}).length === 0 && data?.error) {
                // eslint-disable-next-line no-console
                console.error("Error fetching feature flags:", {
                    error: data?.error,
                    spec,
                    specEnv,
                    configName,
                });
            }

            return data?.data || {};
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Error fetching feature flags:", {
                error: error,
                spec,
                specEnv,
                configName,
                status: error?.response?.status,
                url: error?.config?.url,
            });
            return {};
        }
    });

    try {
        return await featureFlagsPromise;
    } finally {
        featureFlagsPromise = null;
    }
}
